import { Select, SelectProps } from 'antd'
import React from 'react'
import { useFacebookAccounts } from '../hooks'

export function FacebookAccountSelect({ ...props }: SelectProps) {
    const facebookAccountsQuery = useFacebookAccounts()

    return (
        <Select
            showSearch
            optionFilterProp="label"
            allowClear
            loading={facebookAccountsQuery.isPending}
            options={facebookAccountsQuery.data?.map(({ id, name }) => ({ value: id, label: name }))}
            {...props}
        />
    )
}
